import { render, staticRenderFns } from "./course-quiz.html?vue&type=template&id=0417b4ad&scoped=true&"
import script from "./course-quiz.js?vue&type=script&lang=js&"
export * from "./course-quiz.js?vue&type=script&lang=js&"
import style0 from "./course-quiz.css?vue&type=style&index=0&id=0417b4ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0417b4ad",
  null
  
)

export default component.exports